import { Trans, useLingui } from '@lingui/react/macro';

import InlineText from '@/design_system/Typography/InlineText';
import IconStoreRepair from '@/icons/StoreRepair.svg';
import { BaseNotification } from '@/layouts/App/Navbar/NotificationList/components/BaseNotification/BaseNotification';
import { useArticleName } from '@/models/article';
import type { TNotificationOfType } from '@/models/notification';

export const AnalysisRefusedNotification = ({
  notification,
}: {
  notification: TNotificationOfType<'analysis_refused'>;
}) => {
  const { t } = useLingui();

  const articleName = useArticleName({ article: notification.article });
  const requestReference = notification.request.reference;
  const { workshopName } = notification.data;

  return (
    <BaseNotification
      notificationLabel={t({
        id: 'notification.analysis-refused.label',
        message: `${workshopName} has refused the job for the item ${articleName} of request ${requestReference}`,
      })}
      icon={<IconStoreRepair />}
      type="warning"
      notification={notification}
      notificationHeader={(color) => (
        <Trans id="notification.analysis-refused">
          <InlineText weight="medium" color={color}>
            {workshopName}
          </InlineText>{' '}
          has refused the job for the item {articleName}
        </Trans>
      )}
    />
  );
};
